import { Box, SxProps, Theme } from '@mui/material';
import Grid from '@mui/material/Grid';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

type TabControlsProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

const TabControls = ({ children, sx = {} }: TabControlsProps) => (
  <Grid container sx={{ justifyContent: 'flex-end', ...sx }}>
    <Grid size={{ xs: 12, md: 'auto' }}>
      <Box
        sx={(theme) => ({
          mb: theme.spacing(spacingSizeMap.L),
          mt: theme.spacing(-6),
        })}
      >
        {children}
      </Box>
    </Grid>
  </Grid>
);

export default TabControls;
